import React from 'react';

export const SuccessScreen = () => <div>Success screen here</div>;

SuccessScreen.displayName = 'SuccessScreen';
